import apiService from './apiService';

export const roleService = {
    getAll:     ()         => apiService.get('/roles'),
    getById:    (id)       => apiService.get(`/roles/${id}`),
    create:     (data)     => apiService.post('/roles', data),
    update:     (id, data) => apiService.put(`/roles/${id}`, data),
    delete:     (id)       => apiService.delete(`/roles/${id}`),
    getCatalog: ()         => apiService.get('/permissions/catalog'),
};
